/**
 * Custom JS limpo e seguro
 */

/* BOTÃO SCROLL MOBILE */
if (window.matchMedia("(max-width: 768px)").matches) {
  window.onscroll = function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
        btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }
}

/* FUNÇÃO DE PARCELAMENTO */
function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim();
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.');
  
  compare = parseFloat(compare);
  preco = parseFloat(preco);

  if (!isNaN(compare) && compare > 0) {
    var precompare = (compare - preco).toFixed(2).replace('.', ',');
    $('.product-label.product-label--on-sale span').text('R$ ' + precompare);

    var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0];
    $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%');
  }

  var calculo = ((preco + 0) * 1.1979) / 12;
  calculo = calculo.toFixed(2).replace('.', ',');
  calculo = 'R$ ' + calculo;

  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}

/* ATUALIZA QUANDO TROCA VARIANTE */
$(".block-swatch__radio").change(function () {
  setTimeout(function () {
    parcelamento();
  }, 150);
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.power-cards');
  const cards = document.querySelectorAll('.power-card');
  const dots = document.querySelectorAll('.dot');

  if (!container || cards.length === 0) return;

  const getCardWidth = () => cards[0].offsetWidth + 16; // 🔥 16 = gap

  const updateDots = () => {
    const scrollLeft = container.scrollLeft;
    const cardWidth = getCardWidth();

    let index = Math.round(scrollLeft / cardWidth);

    if (index >= dots.length) index = dots.length - 1;

    dots.forEach(dot => dot.classList.remove('active'));
    dots[index].classList.add('active');
  };

  container.addEventListener('scroll', updateDots);

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      container.scrollTo({
        left: getCardWidth() * i,
        behavior: 'smooth'
      });
    });
  });
});
/* ================= CARROSSEL FLAVORS FINAL ================= */

document.addEventListener("DOMContentLoaded", function(){

  const cards = Array.from(document.querySelectorAll('.flavor-card'));
  const btnRight = document.querySelector('.arrow.right');
  const btnLeft = document.querySelector('.arrow.left');
  const carousel = document.querySelector('.flavor-carousel');

  if(!cards.length || !carousel) return;

  const order = ["red","yellow","green","pink","blue"];
  let current = 0;
  let autoRotate;

  /* ================= UPDATE ================= */

  function update(){

    cards.forEach(card=>{
      card.classList.remove('left','center','right','hidden');
    });

    const total = order.length;

    const center = order[current];
    const left = order[(current - 1 + total) % total];
    const right = order[(current + 1) % total];

    cards.forEach(card=>{
      const flavor = card.dataset.flavor;

      if(flavor === center){
        card.classList.add('center');
      }
      else if(flavor === left){
        card.classList.add('left');
      }
      else if(flavor === right){
        card.classList.add('right');
      }
      else{
        card.classList.add('hidden');
      }
    });

  }

  /* ================= NAV ================= */

  function next(){
    current = (current + 1) % order.length;
    update();
  }

  function prev(){
    current = (current - 1 + order.length) % order.length;
    update();
  }

  /* ================= BOTÕES ================= */

  if(btnRight){
    btnRight.addEventListener('click', next);
  }

  if(btnLeft){
    btnLeft.addEventListener('click', prev);
  }

  /* ================= AUTO ROTATE ================= */

  function startAuto(){
    autoRotate = setInterval(next, 4000);
  }

  function stopAuto(){
    clearInterval(autoRotate);
  }

  carousel.addEventListener('mouseenter', stopAuto);
  carousel.addEventListener('mouseleave', startAuto);

  /* ================= SWIPE (SÓ NO CAROUSEL) ================= */

  let startX = 0;
  let isDown = false;

  carousel.addEventListener('mousedown', e=>{
    isDown = true;
    startX = e.clientX;
  });

  carousel.addEventListener('mouseup', e=>{
    if(!isDown) return;
    isDown = false;

    let diff = e.clientX - startX;

    if(diff > 60) prev();
    if(diff < -60) next();
  });

  carousel.addEventListener('mouseleave', ()=> isDown = false);

  /* ================= TOUCH MOBILE ================= */

  carousel.addEventListener('touchstart', e=>{
    startX = e.touches[0].clientX;
  });

  carousel.addEventListener('touchend', e=>{
    let endX = e.changedTouches[0].clientX;
    let diff = endX - startX;

    if(diff > 60) prev();
    if(diff < -60) next();
  });

  /* ================= INIT ================= */

  update();
  startAuto();

});